import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Booking from "./pages/Booking";
import ClientPortal from "./pages/ClientPortal";
import AdminDashboard from "./pages/AdminDashboard";
import EmployeeApp from "./pages/EmployeeApp";
import Album from "./pages/Album";
import ReportLookup from "./pages/ReportLookup";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/reserver" element={<Booking />} />
            <Route path="/album" element={<Album />} />
            <Route path="/rapport/:code" element={<ReportLookup />} />
            <Route path="/portail" element={<ProtectedRoute roles={["client"]}><ClientPortal /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute roles={["admin"]}><AdminDashboard /></ProtectedRoute>} />
            <Route path="/employe" element={<ProtectedRoute roles={["employee"]}><EmployeeApp /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
